import { useTechnicalController } from './technical.controller';

export default function TechnicalView() {
  useTechnicalController();

  return <></>;
}
